export default __webpack_public_path__ + "static/media/AddCommentIcon.22da9d15.svg";